import Vue from "vue";
import { Street } from "./street";
import { Permissoes } from "./permissoes";

export class Config {
    static create() {
        return {
            radius: {
                port: 1812,
                secret: "1234"
            },
            link_total: 0,
            nome: null,
            email: null,
            gerencianet: {
                client_secret: null,
                client_id: null,
                sandbox: true
            },
            icinga_api: {
                uri: null,
                username: null,
                password: null
            },
            permissoes: Permissoes.create(),
            street: Street.create()
        };
    }

    /**
     *
     * @param data
     * @return {Promise}
     */
    static save(data) {
        return new Promise((resolve, reject) => {
            let promisse = null;

            if (data._id) {
                promisse = Vue.http.put("config", data);
            } else {
                promisse = Vue.http.post("config", data);
            }

            promisse.then(() => resolve(), err => reject(err));
        });
    }

    /**
     *
     * @param data
     * @return {Promise}
     */
    static saveGestor(data) {
        return new Promise((resolve, reject) => {
            Vue.http
                .put("config/gestor", data)
                .then(() => resolve(), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static get() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("config")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static byPK(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("empresa/" + id)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static remove(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .delete("empresa/" + id)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static all() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("empresas")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static allIcinga() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("icinga")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param host
     * @return {Promise}
     */
    static removeIcinga(host) {
        return new Promise((resolve, reject) => {
            Vue.http
                .delete("icinga/" + host)
                .then(res => resolve(res.data), err => reject(err));
        });
    }
}
